/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MachineSubscriptionItemDTO } from './machineSubscriptionItemDTO';


export interface MachineSubscriptionsResponseDTO { 
    subscriberId?: string;
    geaPUID?: string;
    organizationId?: string;
    subscriptions?: Array<MachineSubscriptionItemDTO>;
}

